import ConnectedFreedomPayModule from './ConnectedFreedomPayModule';

export default ConnectedFreedomPayModule;
